import {
  IActiveUserRegistrationData,
  IAuthData,
  ILoginAction,
  ILoginPayloadData,
  IRegisterUserDataAfterOtpVerification,
  IRegisterUserDataAfterOtpVerificationAction,
  IResetPasswordAction,
  IResetPasswordPayload,
  ISendOtpAction,
  ISendOtpActionPayload,
  IVerifyOtpAction,
  IVerifyOtpActionPayload,
  ISetActiveUserRegisterAction,
  IRegisterUserActionFailure,
} from "@common/redux/auth/interface";
import { IProfileData } from "../profile/interface";

const prefix = "auth/";

export const authActions = {
  LOGIN: `${prefix}LOGIN`,
  LOGIN_SUCCESS: `${prefix}LOGIN_SUCCESS`,
  LOGIN_FAILURE: `${prefix}LOGIN_FAILURE`,

  LOGOUT: `${prefix}LOGOUT`,
  LOGOUT_SUCCESS: `${prefix}LOGOUT_SUCCESS`,
  LOGOUT_FAILURE: `${prefix}LOGOUT_FAILURE`,

  UPDATE_AUTH_TOKEN: `${prefix}UPDATE_AUTH_TOKEN`,

  SET_ACTIVE_USER_REGISTER: `${prefix}SET_ACTIVE_USER_REGISTER`,

  REGISTER_USER_AFTER_OTP_VERIFICATION: `${prefix}REGISTER_USER_AFTER_OTP_VERIFICATION`,
  REGISTER_USER_AFTER_OTP_VERIFICATION_SUCCESS: `${prefix}REGISTER_USER_AFTER_OTP_VERIFICATION_SUCCESS`,
  REGISTER_USER_AFTER_OTP_VERIFICATION_FAILURE: `${prefix}REGISTER_USER_AFTER_OTP_VERIFICATION_FAILURE`,

  SEND_OTP: `${prefix}SEND_OTP`,
  VERIFY_OTP: `${prefix}VERIFY_OTP`,
  RESET_PASSWORD: `${prefix}RESET_PASSWORD`,
  UPDATE_PROFILE_DATA: `${prefix}SET_PROFILE_DATA`,
  RESET_USER_REGISTER_ERROR: `${prefix}RESET_USER_REGISTER_ERROR`,
};

export const loginAction = (
  loginPayloadData: ILoginPayloadData
): ILoginAction => {
  return {
    type: authActions.LOGIN,
    payload: {
      loginPayloadData,
    },
  };
};

export const updateUserProfileData = (profileData: IProfileData) => {
  return {
    type: authActions.UPDATE_PROFILE_DATA,
    payload: {
      profileData,
    },
  };
};
export const loginSuccessAction = (authData: IAuthData) => {
  return {
    type: authActions.LOGIN_SUCCESS,
    payload: {
      authData,
    },
  };
};

export const loginFailureAction = (error: string) => {
  return {
    type: authActions.LOGIN_FAILURE,
    payload: error,
  };
};

export const setActiveUserRegisterAction = (
  activeUserRegistrationData: IActiveUserRegistrationData
): ISetActiveUserRegisterAction => {
  return {
    type: authActions.SET_ACTIVE_USER_REGISTER,
    payload: {
      activeUserRegistrationData,
    },
  };
};

export const logoutAction = () => {
  return {
    type: authActions.LOGOUT,
  };
};

export const logoutSuccessAction = () => {
  return {
    type: authActions.LOGOUT_SUCCESS,
  };
};

export const logoutFailureAction = (error: string) => {
  return {
    type: authActions.LOGOUT_FAILURE,
    payload: error,
  };
};

export const registerUserAfterOtpVerificationAction = (
  registeringUserData: IRegisterUserDataAfterOtpVerification
): IRegisterUserDataAfterOtpVerificationAction => {
  return {
    type: authActions.REGISTER_USER_AFTER_OTP_VERIFICATION,
    payload: registeringUserData,
  };
};

export const registerUserAfterOtpVerificationActionSuccess = (
  registeredUserData: IAuthData
) => {
  return {
    type: authActions.REGISTER_USER_AFTER_OTP_VERIFICATION_SUCCESS,
    payload: registeredUserData,
  };
};

export const registerUserAfterOtpVerificationActionFailure = (
  error: IRegisterUserActionFailure
) => {
  return {
    type: authActions.REGISTER_USER_AFTER_OTP_VERIFICATION_FAILURE,
    payload: error,
  };
};

export const sendOtpAction = (
  sendOtpActionPayload: ISendOtpActionPayload
): ISendOtpAction => {
  return {
    type: authActions.SEND_OTP,
    payload: sendOtpActionPayload,
  };
};

export const verifyOtpAction = (
  verifyOtpActionPayload: IVerifyOtpActionPayload
): IVerifyOtpAction => {
  return {
    type: authActions.VERIFY_OTP,
    payload: verifyOtpActionPayload,
  };
};

export const resetPasswordAction = (
  resetPasswordActionPayload: IResetPasswordPayload
): IResetPasswordAction => {
  return {
    type: authActions.RESET_PASSWORD,
    payload: resetPasswordActionPayload,
  };
};

export const resetRegisterUserErrorAction = () => {
  return {
    type: authActions.RESET_USER_REGISTER_ERROR,
  };
};

export const updateAuthToken = (sessionToken: string) => {
  return {
    type: authActions.UPDATE_AUTH_TOKEN,
    payload: sessionToken,
  };
};
